export default __webpack_public_path__ + "static/peaq-45226850e0f1e1a8389ddc3eb708cb84.svg";